import React, { useEffect, useRef, useState } from 'react';
import { Button, Drawer, Tooltip } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { MdArrowBack } from 'react-icons/md';
import { getDirection } from '../../helpers';
import { useStore } from '../../store/rootStore';
import NotificationsList from './layout/List';
import NotificationDetails from './layout/Details';
import drawerStyles from '../SettingsDrawer/SettingsDrawer.module.scss';
const NotificationsDrawer = () => {
    const { notificationsStore } = useStore();
    const { t } = useTranslation();
    const [selectedId, setSelectedId] = useState();
    const notificationButton = useRef();
    const list = useRef(null);
    const isRtl = getDirection() === 'rtl';
    useEffect(() => {
        if (!notificationsStore.isOpen) {
            setSelectedId(undefined);
        }
    }, [notificationsStore.isOpen]);
    const restoreListFocus = (open) => {
        if (open || !notificationsStore.isOpen)
            return;
        requestAnimationFrame(() => {
            var _a, _b, _c;
            if (!notificationsStore.isOpen)
                return;
            if ((_a = notificationButton.current) === null || _a === void 0 ? void 0 : _a.isConnected) {
                notificationButton.current.focus();
            }
            else {
                (_c = (_b = list.current) === null || _b === void 0 ? void 0 : _b.querySelector('[role="tab"][aria-selected="true"]')) === null || _c === void 0 ? void 0 : _c.focus();
            }
        });
    };
    const closeDrawer = () => notificationsStore.setIsOpen(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Drawer, { className: classNames(drawerStyles.drawer, { [drawerStyles.rtl]: isRtl }), open: notificationsStore.isOpen, onClose: closeDrawer, placement: isRtl ? 'right' : 'left', width: 320, title: t('notifications'), closeIcon: React.createElement(MdArrowBack, { className: drawerStyles.closeIcon }), extra: React.createElement(Tooltip, { title: t('markAllNotificationsAsRead') },
                React.createElement("span", null,
                    React.createElement(Button, { type: "text", className: drawerStyles.headerCreateButton, icon: React.createElement(CheckOutlined, null), "aria-label": t('markAllNotificationsAsRead'), disabled: !notificationsStore.unreadCount, onClick: () => {
                            void notificationsStore.markAllAsRead();
                        } }))), bodyStyle: { padding: 0 }, destroyOnClose: true },
            React.createElement("div", { ref: list },
                React.createElement(NotificationsList, { selectedId: selectedId, onNotificationClick: (id, button) => {
                        notificationButton.current = button;
                        setSelectedId(id);
                    } }))),
        React.createElement(Drawer, { className: classNames(drawerStyles.drawer, drawerStyles.secondLevel, { [drawerStyles.rtl]: isRtl }), open: notificationsStore.isOpen && !!selectedId, onClose: () => setSelectedId(undefined), afterOpenChange: restoreListFocus, placement: isRtl ? 'right' : 'left', width: 368, title: t('details'), closeIcon: React.createElement(MdArrowBack, { className: drawerStyles.closeIcon }), bodyStyle: { padding: 0 }, destroyOnClose: true }, selectedId && (React.createElement(NotificationDetails, { key: selectedId, id: selectedId, onResolved: () => setSelectedId((currentId) => (currentId === selectedId ? undefined : currentId)) })))));
};
export default observer(NotificationsDrawer);
